import type { CSSProperties } from 'react';

export type ControlsTheme = 'minimal' | 'solid' | 'duotone' | 'bold' | 'safari';

export interface ThemeStyles {
  // Classe aplicada ao wrapper redondo do botão de controle
  wrapperClass: string;
  // CSS aplicado ao SVG/ícone interno
  iconStyle: CSSProperties;
}

const BASE_BTN = 'h-8 w-8 flex items-center justify-center rounded-full transition-colors hover:bg-white/15';

// Botão estilo Safari/iOS: cada controle num círculo translúcido com blur +
// anel sutil. Diferente dos outros temas (wrapper neutro pra deixar o ícone
// falar), aqui a identidade está no PRÓPRIO botão — espelha os controles do
// player em tela cheia do Safari.
const SAFARI_BTN = 'h-8 w-8 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-md ring-1 ring-white/25 shadow-sm transition-colors hover:bg-white/20';

export const getThemeStyles = (theme: ControlsTheme, color = '#FFFFFF'): ThemeStyles => {
  // O glyph já muda por tema (via ThemedIcon). No tema 'safari' o wrapper
  // também ganha o círculo translúcido; nos demais segue neutro.
  return {
    wrapperClass: theme === 'safari' ? SAFARI_BTN : BASE_BTN,
    iconStyle: { color },
  };
};
